<template>
  <div id="chartContainer">
    <div class="row">
      <div class="col-sm-6">
        <v-select v-model="chartType" :options="options" />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <HeatMapChart v-show="chartType.value === 'heatmap'" />
        <ColumnChart v-show="chartType.value === 'volume'"/>
        <LineChart v-show="chartType.value === 'customers_helped'" />
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import HeatMapChart from './HeatMapChart'
import ColumnChart from './ColumnChart'
import LineChart from './LineChart'
export default {
  name: 'MailboxOverviewChart',
  props: ['startDate', 'endDate'],
  components: {
    HeatMapChart,
    ColumnChart,
    LineChart
  },
  data () {
    return {
      chartType: {
        value: 'volume',
        label: 'New Conversations'
      },
      options: [
        {value: 'volume', label: 'New Conversations'},
        // {value: 'new_messages', label: 'Emails Received'},
        // {value: 'total_messages', label: 'Messages Recieved'},
        {value: 'heatmap', label: 'Busiest Time Of Day'},
        {value: 'customers_helped', label: 'Customers Helped'}
      ]
    }
  },
  computed: {
    ...mapGetters(['currentReportMailbox', 'reportDates']),
    chartOptions: function () {
      if (this.chartType.value === 'volume') {
        return this.columnChart
      } else if (this.chartType.value === 'heatmap') {
        return this.heatMapChart
      }
    }
  }
}
</script>
<style scoped>
#chartContainer{
  margin-top: 10px;
  border: 1px solid #cec3c3;
  border-radius: 7px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reports/MailboxOverviewChart.vue